import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import GlobalNav from './components/GlobalNav';
import BottomNav from './components/BottomNav';
import InstallBanner from './components/InstallBanner';
import Home from './components/Home';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import AdminPage from './components/AdminPage';
import AccountPage from './components/AccountPage';
import ConfirmEmail from './components/ConfirmEmail';
import SubscriptionReturnPage from './components/SubscriptionReturnPage';
import GoogleCallback from './components/GoogleCallback';
import LoginVerifyPage from './components/LoginVerifyPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsOfServicePage from './components/TermsOfServicePage';
import LanguageSetupPage from './components/LanguageSetupPage';
import FeedbackPage from './components/FeedbackPage';
import { isPublicPath } from './lib/analytics';

// BottomNav is fixed to the bottom on mobile for every route whenever the visitor
// is signed in (see BottomNav.js) — not just the handful of pages someone might
// expect it on. Reserving the space here, keyed on the same isAuthenticated check
// BottomNav itself uses, covers every route (including ones like Home or the legal
// pages that a signed-in user can still reach) without relying on each page
// remembering its own bottom padding.
function MainContent({ children }) {
  const { isAuthenticated } = useAuth();
  return <main className={isAuthenticated ? 'pb-20 md:pb-0' : undefined}>{children}</main>;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-background text-foreground" data-l-private={isPublicPath(pathname) ? undefined : ''}>
      {children}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Shell>
          <GlobalNav />
          <MainContent>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/login/verify" element={<LoginVerifyPage />} />
              <Route path="/register" element={<Navigate to="/login" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/subscription/return" element={<SubscriptionReturnPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/confirm-email/:token" element={<ConfirmEmail />} />
              <Route path="/auth/google/callback" element={<GoogleCallback />} />
              <Route path="/forgot-password" element={<Navigate to="/login" replace />} />
              <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/language-setup" element={<LanguageSetupPage />} />
              <Route path="/feedback" element={<FeedbackPage />} />
            </Routes>
          </MainContent>
          <BottomNav />
          <InstallBanner />
        </Shell>
      </Router>
    </AuthProvider>
  );
}

export default App;

